(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soulmates-club"]) return;
  try {
    
window.addEventListener("pageshow", (event) => {
  if (event.persisted && document.querySelector(".sc-club")) window.location.reload();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soulmates-room"] && !Shopify.designMode) return;
  try {
    
function initSoulmatesRooms(){
  document.querySelectorAll('[data-sc-room]').forEach(room=>{
    if(room.dataset.ready)return;
    room.dataset.ready='true';

    const roomScene=room.querySelector('.sc-room__scene');

    if(roomScene&&window.matchMedia('(hover: hover) and (pointer: fine)').matches){
      room.addEventListener('pointermove',e=>{
        const rect=room.getBoundingClientRect();
        const x=(e.clientX-rect.left)/rect.width-.5;
        const y=(e.clientY-rect.top)/rect.height-.5;
        room.style.setProperty('--sc-room-move-x',`${-x*40}px`);
        room.style.setProperty('--sc-room-move-y',`${-y*40}px`);
      });

      room.addEventListener('pointerleave',()=>{
        room.style.setProperty('--sc-room-move-x','0px');
        room.style.setProperty('--sc-room-move-y','0px');
      });
    }
    
    const fan=room.querySelector('.sc-room__fan');
    const dragon=room.querySelector('.sc-room__dragon');
    const greeting=room.querySelector('.sc-room__greeting');
    let fanAudio=null;
    const stopFanAudio=()=>{
      if(!fanAudio)return;
      const old=fanAudio;
      fanAudio=null;
      const now=old.context.currentTime;
      const hold=parameter=>{
        if(parameter.cancelAndHoldAtTime)parameter.cancelAndHoldAtTime(now);
        else{const value=parameter.value;parameter.cancelScheduledValues(now);parameter.setValueAtTime(value,now);}
      };
      const duration=1.8;
      const slow=(parameter,target)=>{
        hold(parameter);
        parameter.linearRampToValueAtTime(target,now+duration);
      };
      slow(old.bladeLfo.frequency,.25);
      hold(old.gain.gain);
      const level=old.gain.gain.value;
      const fade=Float32Array.from({length:61},(_,index)=>level*Math.pow(1-index/60,1.2));
      old.gain.gain.setValueCurveAtTime(fade,now,duration);
      setTimeout(()=>old.context.close().catch(()=>{}),2100);
    };
    

    const startFanAudio=()=>{
      if(fanAudio){fanAudio.context.resume().catch(()=>{});return;}
      const AudioEngine=window.AudioContext||window.webkitAudioContext;
      if(!AudioEngine)return;
      try{
        const context=new AudioEngine();

        const buffer=context.createBuffer(
          1,context.sampleRate*3,context.sampleRate
        );
        const samples=buffer.getChannelData(0);
        let soft=0;

        for(let i=0;i<samples.length;i++){
          soft=.96*soft+.04*(Math.random()*2-1);
          samples[i]=soft*3;
        }

        const airflow=context.createBufferSource();
        airflow.buffer=buffer;
        airflow.loop=true;

        const filter=context.createBiquadFilter();
        filter.type='lowpass';
        filter.frequency.value=1100;

        const gain=context.createGain();
        gain.gain.value=0;
        gain.gain.setValueAtTime(0,context.currentTime);
        gain.gain.linearRampToValueAtTime(.1,context.currentTime+2);

        const fanLevel=context.createGain();
        fanLevel.gain.value=.65;
        airflow.connect(filter).connect(gain).connect(fanLevel).connect(context.destination);

        const motor=context.createOscillator();
        const motorGain=context.createGain();
        motor.type='sine';
        motor.frequency.value=150;
        motorGain.gain.value=.045;
        motor.connect(motorGain).connect(gain);

        const bladeLfo=context.createOscillator();
        const bladeDepth=context.createGain();
        bladeLfo.type='sine';
        bladeLfo.frequency.value=1;
        bladeLfo.frequency.setTargetAtTime(4,context.currentTime,1.2);
        bladeDepth.gain.value=.022;

        bladeLfo.connect(bladeDepth);
        bladeDepth.connect(gain.gain);

        airflow.start();
        motor.start();
        bladeLfo.start();

        fanAudio={context,gain:fanLevel,bladeLfo,bladeDepth,motor,airflow,filter};
        context.resume().catch(stopFanAudio);
      }catch(error){
        stopFanAudio();
      }
    };
    

      const playFanSwitch = () => {
        const AudioEngine = window.AudioContext || window.webkitAudioContext;
        if (!AudioEngine) return;

        let context;

        try {
          context = new AudioEngine();

          const playClick = (time, volume = 1, pitch = 1) => {
            const noise = context.createBuffer(
              1,
              Math.ceil(context.sampleRate * 0.055),
              context.sampleRate
            );

            const samples = noise.getChannelData(0);

            for (let i = 0; i < samples.length; i++) {
              samples[i] =
                (Math.random() * 2 - 1) *
                Math.exp(-i / (context.sampleRate * 0.009));
            }

            const click = context.createBufferSource();
            click.buffer = noise;

            const filter = context.createBiquadFilter();
            filter.type = 'bandpass';
            filter.frequency.value = 1500 * pitch;
            filter.Q.value = 0.7;

            const level = context.createGain();
            level.gain.setValueAtTime(0, time);
            level.gain.linearRampToValueAtTime(
              0.45 * volume,
              time + 0.003
            );
            level.gain.exponentialRampToValueAtTime(
              0.0001,
              time + 0.055
            );

            click.connect(filter).connect(level).connect(context.destination);
            click.start(time);
            click.stop(time + 0.06);

            const body = context.createOscillator();
            body.type = 'triangle';
            body.frequency.setValueAtTime(420 * pitch, time);
            body.frequency.exponentialRampToValueAtTime(
              110 * pitch,
              time + 0.045
            );

            const envelope = context.createGain();
            envelope.gain.setValueAtTime(0.16 * volume, time);
            envelope.gain.exponentialRampToValueAtTime(
              0.0001,
              time + 0.055
            );

            body.connect(envelope).connect(context.destination);
            body.start(time);
            body.stop(time + 0.06);
          };

          context.resume().then(() => {
            const now = context.currentTime;

            // 第一聲：原本音高
            playClick(now, 1, 1);

            // 第二聲：提高音高、稍微降低音量
            playClick(now + 0.13, 0.25, 1.8);

            setTimeout(() => {
              context.close().catch(() => {});
            }, 300);
          }).catch(() => context.close().catch(() => {}));

        } catch (error) {
          if (context) context.close().catch(() => {});
        }
      };


    const blades=fan.querySelector('.sc-room__fan-blades');
    let bladeAnimation=null;
    const holdBladeAngle=()=>{
      const transform=getComputedStyle(blades).transform;
      const matrix=new DOMMatrixReadOnly(transform==='none'?undefined:transform);
      const angle=Math.atan2(matrix.b,matrix.a)*180/Math.PI;
      if(bladeAnimation)bladeAnimation.cancel();
      bladeAnimation=null;
      blades.style.transform=`rotate(${angle}deg)`;
      return angle;
    };
    const startBlades=()=>{
      const angle=holdBladeAngle();
      const duration=1500;
      const travel=(360/.55)*(duration/1000)/2;
      const frames=Array.from({length:26},(_,index)=>{
        const progress=index/25;
        return {offset:progress,transform:`rotate(${angle+travel*progress*progress}deg)`,easing:'steps(1,end)'};
      });
      const animation=blades.animate(frames,{duration,fill:'forwards'});
      bladeAnimation=animation;
      animation.onfinish=()=>{
        if(bladeAnimation!==animation||fan.getAttribute('aria-pressed')!=='true')return;
        const base=angle+travel;
        blades.style.transform=`rotate(${base}deg)`;
        animation.cancel();
        bladeAnimation=blades.animate([
          {transform:`rotate(${base}deg)`},
          {transform:`rotate(${base+360}deg)`}
        ],{duration:550,iterations:Infinity,easing:'steps(10,end)'});
      };
    };
    const coastBlades=()=>{
      const angle=holdBladeAngle();
      const duration=1800;
      const travel=(360/.55)*(duration/1000)/2;
      const frames=Array.from({length:31},(_,index)=>{
        const progress=index/30;
        return {offset:progress,transform:`rotate(${angle+travel*(2*progress-progress*progress)}deg)`,easing:'steps(1,end)'};
      });
      const animation=blades.animate(frames,{duration,fill:'forwards'});
      bladeAnimation=animation;
      animation.onfinish=()=>{
        if(bladeAnimation!==animation)return;
        blades.style.transform=`rotate(${angle+travel}deg)`;
        animation.cancel();
        bladeAnimation=null;
      };
    };
    fan.addEventListener('click',()=>{
      playFanSwitch();
      const running=fan.getAttribute('aria-pressed')!=='true';
      fan.setAttribute('aria-pressed',String(running));
      if(running){startBlades();startFanAudio();}
      else{coastBlades();stopFanAudio();}
    });
    const stopFan=()=>{
      fan.setAttribute('aria-pressed','false');
      holdBladeAngle();
      stopFanAudio();
    };
    document.addEventListener('visibilitychange',()=>{if(document.hidden)stopFan();});
    window.addEventListener('pagehide',stopFan);
    const letter=room.querySelector('.sc-room__letter');
    const news=room.querySelector('.sc-room__news:not(.sc-room__fortune)');
    const musicButton=room.querySelector('.sc-room__music');
    const musicStatus=room.querySelector('.sc-room__music-status');
    letter.addEventListener('click',()=>{
      if(news.open)return;

      playFanSwitch();
      letter.dataset.read='true';

      news.classList.remove('sc-room__news--dark','sc-room__news--opening');
      news.showModal();

      requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
          news.classList.add('sc-room__news--dark','sc-room__news--opening');
        });
      });

      setTimeout(()=>{
        news.classList.remove('sc-room__news--opening');
      },1000);
    });
    window.addEventListener('pageshow',event=>{if(event.persisted){letter.dataset.read='false';if(news.open)news.close();}});
    news.querySelector('.sc-room__news-close').addEventListener('click',()=>{playFanSwitch();news.close();});
    news.addEventListener('click',event=>{if(event.target===news){const r=news.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)news.close();}});
  
    let musicContext = null;
    let musicTimer = null;
    let musicStarting = false;
    let musicMaster = null;
    let musicSeasonChecker = null;
    let musicSeasonKey = null;
    let musicSwitching = false;
    let musicGeneration = 0;

    const MUSIC_BPM = 96;
    const MUSIC_BEAT = 60 / MUSIC_BPM;

    // 所有日期均依照台灣時間判斷
    const getTaiwanDate = () => {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Taipei',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }).formatToParts(new Date());

      const result = {};
      parts.forEach(part => {
        if (part.type !== 'literal') {
          result[part.type] = Number(part.value);
        }
      });

      return result;
    };

    // 12/1～12/25 播放聖誕音樂
      const getCurrentSeasonMusic = () => {
        const preview = document.documentElement.dataset.scSeasonPreview;
        if (['spring','summer','autumn','winter','halloween','christmas','newyear'].includes(preview)) return preview;
        const { month, day } = getTaiwanDate();

        // 萬聖節：10 月整個月
        if (month === 10) return 'halloween';

        // 聖誕節：12/1～12/25
        if (month === 12 && day <= 25) return 'christmas';

        // 新年：2 月整個月
        if (month === 2) return 'newyear';

        // 四季音樂
        if (month >= 3 && month <= 5) return 'spring';
        if (month >= 6 && month <= 8) return 'summer';
        if (month >= 9 && month <= 11) return 'autumn';

        // 12/26～1 月：冬季
        return 'winter';
      };


    const scene = room.querySelector('.sc-room__scene');
    const originalScene = scene.getAttribute('src');
    const originalGreeting = greeting.innerHTML;
    const roomScenes = {"summer": {"url": "https://cdn.shopify.com/s/files/1/1003/5609/6321/files/soulmates-room-summer-20261101.png?v=1793525811", "sx": 1.009388, "sy": 0.991613, "tx": -0.627676, "ty": 0.045906}, "autumn": {"url": "https://cdn.shopify.com/s/files/1/1003/5609/6321/files/soulmates-room-autumn-20261101.png?v=1793525825", "sx": 0.993391, "sy": 0.986011, "tx": 0.63093, "ty": 0.544783}, "spring": {"url": "https://cdn.shopify.com/s/files/1/1003/5609/6321/files/soulmates-room-spring-20261101.png?v=1793525845", "sx": 1.002591, "sy": 0.990698, "tx": -0.185027, "ty": 0.203443}, "winter": {"url": "https://cdn.shopify.com/s/files/1/1003/5609/6321/files/soulmates-room-winter-20261101.png?v=1793525857", "sx": 0.996776, "sy": 0.994206, "tx": 0.034414, "ty": -2.649104}};
    let requestedScene = '';
    let sceneRequest = 0;
    const syncRoomScene = season => {
      const config = roomScenes[season];
      const url = config ? config.url : originalScene;
      if (requestedScene === url) return;
      requestedScene = url;
      const request = ++sceneRequest;
      const image = new Image();
      image.onload = () => {
        if (request !== sceneRequest || !room.isConnected) return;
        scene.src = url;
        scene.style.transformOrigin = '0 0';
        scene.style.transform = config ? `translate(${config.tx}%,${config.ty}%) scale(${config.sx},${config.sy})` : '';
        scene.style.clipPath = config ? 'none' : '';
        scene.style.filter = config ? `url(#${room.querySelector('filter').id})` : '';
        room.dataset.sceneSeason = config ? season : 'default';
      };
      image.onerror = () => { if (request === sceneRequest) requestedScene = ''; };
      image.src = url;
    };
    let fanSeason = null;
    const seasonalAbort = new AbortController();
    const syncSeasonalRoom = () => {
      if (!room.isConnected) return;
      const preview = document.documentElement.dataset.scSeasonPreview;
      const month = getTaiwanDate().month;
      const summer = preview ? preview === 'summer' : month >= 6 && month <= 8;
      const winter = preview ? preview === 'winter' || preview === 'christmas' : month === 12 || month === 1;
      const calendarScene = month === 10 || month === 11 ? 'autumn'
        : month === 12 || month === 1 ? 'winter'
        : month === 3 || month === 4 ? 'spring'
        : month >= 6 && month <= 8 ? 'summer' : 'default';
      const chosenScene = preview || calendarScene;
      const sceneSeason = {halloween:'autumn',christmas:'winter',newyear:'default'}[chosenScene] || chosenScene;
      syncRoomScene(sceneSeason);
      if (summer) {
        const link = document.createElement('a');
        link.href = 'https://yondaimesangura.com';
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = 'https://yondaimesangura.com';
        greeting.replaceChildren(document.createTextNode(room.dataset.summerGreeting + ' '),link);
      } else {
        greeting.innerHTML = originalGreeting;
      }
      greeting.hidden = true;
      dragon.setAttribute('aria-expanded','false');
      fan.hidden = winter;
      if (winter) stopFan();
      if (fanSeason !== summer) {
        fanSeason = summer;
        if (summer) {
          fan.setAttribute('aria-pressed','true');
          startBlades();
          startFanAudio();
        } else {
          stopFan();
        }
      }
      room.dataset.musicSeason = getCurrentSeasonMusic();
      if (musicContext && !musicStarting && !musicSwitching) switchSeasonMusic();
    };
    document.addEventListener('sc:season-change',syncSeasonalRoom,{signal:seasonalAbort.signal});
    document.addEventListener('shopify:section:unload',event => {
      if (event.target.contains(room)) seasonalAbort.abort();
    },{signal:seasonalAbort.signal});
    const unlockFanAudio = () => {
      if (fan.getAttribute('aria-pressed') !== 'true') return;
      startFanAudio();
    };
    document.addEventListener('pointerdown',unlockFanAudio,{signal:seasonalAbort.signal,passive:true});
    document.addEventListener('keydown',unlockFanAudio,{signal:seasonalAbort.signal});
    syncSeasonalRoom();


    // 8-bit 旋律：保留原本的合成器音色與 96 BPM
    const SEASON_MUSIC = {
      spring: {
        melody: [
          76,79,81,79,76,72,74,76,
          79,81,84,81,79,76,74,72,
          76,79,84,83,81,79,76,74,
          72,74,76,79,76,74,72,76
        ],
        roots: [48,53,45,41]
      },

      summer: {
        melody: [
          79,84,83,79,76,79,81,84,
          86,84,81,79,76,79,84,79,
          81,84,88,86,84,81,79,76,
          79,81,84,81,79,76,79,84
        ],
        roots: [48,45,41,43]
      },

        autumn: {
          melody: [
            76,0,74,0,71,74,76,0,
            79,0,76,74,72,0,74,0,
            76,0,74,0,71,67,71,0,
            74,0,72,0,76,74,71,0
          ],
          roots: [45,41,48,43]
        },

        winter: {
          melody: [
            72,0,76,0,79,0,76,0,
            72,0,74,0,76,0,72,0,
            69,0,72,0,76,0,74,0,
            72,0,76,0,72,0,69,0
          ],
          roots: [48,43,45,41]
        },

      // 經典 Jingle Bells 旋律改編
      christmas: {
        melody: [
          76,76,76,76,76,76,76,76,
          76,79,72,74,76,0,0,0,
          77,77,77,77,77,76,76,76,
          76,74,74,76,74,79,0,0
        ],
        roots: [48,41,45,43]
      },
      newyear: {
        melody: [57,0,59,0,60,0,62,0,65,0,64,0,64,0,0,0,64,0,69,0,69,0,64,0,64,0,62,0,62,0,0,0,62,0,65,0,64,0,62,0,62,0,60,0,60,0,0,0,60,0,59,0,57,0,55,0,57,0,0,0,57,0,0,0],
        durations: [0.94,0,0.94,0,0.94,0,0.94,0,0.94,0,0.94,0,1.88,0,0,0,0.94,0,0.94,0,0.94,0,0.94,0,0.94,0,0.94,0,1.88,0,0,0,0.94,0,0.94,0,0.94,0,0.94,0,0.94,0,0.94,0,1.88,0,0,0,0.94,0,0.94,0,0.94,0,0.94,0,1.88,0,0,0,1.88,0,0,0],
        roots: [45,45,45,50,50,45,45,45],
        minor: true
      },

      halloween: {
        melody: [
          72,0,72,75, 72,0,70,0,
          72,75,77,0, 75,72,70,0,
          72,0,72,75, 77,75,72,0,
          70,72,75,70, 67,0,67,0
        ],
        roots: [36,39,43,41]
      }
    };
    

    const midiToFrequency = pitch =>
      440 * Math.pow(2, (pitch - 69) / 12);

    const stopMusic = () => {
      // 取消尚未完成的啟動或季節切換
      musicGeneration++;
      musicSwitching = false;
      musicStarting = false;

      if (musicTimer) clearInterval(musicTimer);
      if (musicSeasonChecker) clearInterval(musicSeasonChecker);

      musicTimer = null;
      musicSeasonChecker = null;
      musicSeasonKey = null;

      const oldContext = musicContext;
      const oldMaster = musicMaster;

      musicContext = null;
      musicMaster = null;

      if (oldContext && oldMaster) {
        const now = oldContext.currentTime;

        try {
          oldMaster.gain.cancelScheduledValues(now);
          oldMaster.gain.setValueAtTime(
            oldMaster.gain.value,
            now
          );
          oldMaster.gain.linearRampToValueAtTime(
            0.0001,
            now + 0.15
          );
        } catch (error) {}

        setTimeout(() => {
          oldContext.close().catch(() => {});
        }, 180);
      } else if (oldContext) {
        oldContext.close().catch(() => {});
      }

      musicButton.setAttribute('aria-pressed', 'false');
      musicStatus.hidden = true;
    };

    // 淡出目前音樂，再載入新季節
    const switchSeasonMusic = async () => {
      if (
        !musicContext ||
        !musicMaster ||
        musicSwitching ||
        musicStarting
      ) return;

      const nextSeason = getCurrentSeasonMusic();

      if (nextSeason === musicSeasonKey) return;

      musicSwitching = true;
      const generation = ++musicGeneration;

      if (musicTimer) clearInterval(musicTimer);
      musicTimer = null;

      const oldContext = musicContext;
      const oldMaster = musicMaster;

      musicContext = null;
      musicMaster = null;

      try {
        const now = oldContext.currentTime;

        oldMaster.gain.cancelScheduledValues(now);
        oldMaster.gain.setValueAtTime(
          oldMaster.gain.value,
          now
        );
        oldMaster.gain.linearRampToValueAtTime(
          0.0001,
          now + 0.15
        );
      } catch (error) {}

      await new Promise(resolve => setTimeout(resolve, 180));

      await oldContext.close().catch(() => {});

      // 若使用者中途關閉音樂，不再重新啟動
      if (generation !== musicGeneration) return;

      musicSwitching = false;
      await startMusic();
    };

const startMusic = async () => {
  const AudioEngine =
    window.AudioContext || window.webkitAudioContext;

  if (
    !AudioEngine ||
    musicStarting ||
    musicSwitching ||
    musicContext
  ) return;

  musicStarting = true;
  const generation = musicGeneration;
  let context = null;

  try {
    const season = getCurrentSeasonMusic();
    const musicData = SEASON_MUSIC[season];

    // 依季節設定速度
    const bpm = season === 'newyear' ? 200
      : season === 'halloween' ? 88
      : season === 'autumn' ? 76
      : season === 'winter' ? 68
      : MUSIC_BPM;

    const beat = 60 / bpm;

    context = new AudioEngine();
    musicContext = context;

    await context.resume();

    if (generation !== musicGeneration) {
      await context.close().catch(() => {});
      return;
    }

    const master = context.createGain();
    master.gain.setValueAtTime(0, context.currentTime);
    master.gain.linearRampToValueAtTime(
      1,
      context.currentTime + 0.15
    );
    master.connect(context.destination);

    musicMaster = master;
    musicSeasonKey = season;

    const note = (pitch, start, length, volume, type) => {
      if (!pitch || pitch <= 0) return;

      const oscillator = context.createOscillator();
      const gain = context.createGain();

      oscillator.type = type;
      oscillator.frequency.value =
        440 * Math.pow(2, (pitch - 69) / 12);

      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(
        volume,
        start + 0.015
      );
      gain.gain.exponentialRampToValueAtTime(
        0.0001,
        start + length
      );

      oscillator.connect(gain);
      gain.connect(master);

      oscillator.start(start);
      oscillator.stop(start + length + 0.025);
    };

    let step = 0;
    let next = context.currentTime + 0.05;

    const schedule = () => {
      if (
        context !== musicContext ||
        generation !== musicGeneration
      ) return;

      while (next < context.currentTime + 0.2) {
        const melodyStride = season === 'newyear' ? 2 : 1;
        const melodyStep = Math.floor(step / melodyStride);
        const bar = Math.floor(melodyStep / 8) % musicData.roots.length;
        const root = musicData.roots[bar];
        const leadTime = next + (season === 'newyear' ? beat : 0);

        if (step % melodyStride === 0) {
          note(
            musicData.melody[melodyStep % musicData.melody.length],
            leadTime,
            beat * melodyStride * (musicData.durations ? musicData.durations[melodyStep % musicData.melody.length] : 0.44),
            0.24,
            'triangle'
          );
        }

        if (step % 2 === 0) {
          note(root,next,beat * 0.8,0.28,'sine');
        }

        const chord = [root + 24, root + (musicData.minor ? 27 : 28), root + 31];
        if (step % melodyStride === 0) {
          note(chord[melodyStep % 3],leadTime,beat * melodyStride * 0.35,0.065,'square');
        }

        // 低頻節奏
        if (step % 4 === 0) {
          note(
            36,
            next,
            beat * 0.18,
            0.16,
            'sine'
          );
        }

        next += beat / 2;
        step++;
      }
    };

    schedule();
    musicTimer = setInterval(schedule, 80);

    musicStarting = false;
    musicButton.setAttribute('aria-pressed', 'true');
    musicStatus.hidden = false;

    // 每分鐘檢查台灣日期是否進入新季節
    if (musicSeasonChecker) {
      clearInterval(musicSeasonChecker);
    }

    musicSeasonChecker = setInterval(() => {
      if (
        musicContext &&
        !musicSwitching &&
        !musicStarting &&
        getCurrentSeasonMusic() !== musicSeasonKey
      ) {
        switchSeasonMusic();
      }
    }, 60000);

  } catch (error) {
    if (generation === musicGeneration) {
      stopMusic();
    } else if (context) {
      await context.close().catch(() => {});
    }
  } finally {
    if (generation === musicGeneration) {
      musicStarting = false;
    }
  }
};
    musicButton.addEventListener('click', () => {
      playFanSwitch();

      if (musicContext || musicStarting || musicSwitching) {
        stopMusic();
      } else {
        startMusic();
      }
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopMusic();
    });

    window.addEventListener('pagehide',stopMusic);
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(room)){stopMusic();stopFan();}});
    const tail=room.querySelector('.sc-room__dragon-tail');
    const cookie=room.querySelector('.sc-room__cookie');
    const fortune=room.querySelector('.sc-room__fortune');
    const copyButton=room.querySelector('.sc-room__copy-code');
    const copyStatus=room.querySelector('.sc-room__copy-status');
    const refreshFortuneCode=()=>{
      const {year,month}=getTaiwanDate();
      const code='SOULMATE20-'+year+String(month).padStart(2,'0');
      fortune.querySelector('code').textContent=code;
      return code;
    };
    refreshFortuneCode();
    tail.addEventListener('click',()=>{
      if(!cookie.hidden)return;
      cookie.hidden=false;
      tail.setAttribute('aria-expanded','true');
      cookie.classList.remove('is-launching');
      void cookie.offsetWidth;
      cookie.classList.add('is-launching');
    },{once:true});
    cookie.addEventListener('animationend',()=>cookie.classList.remove('is-launching'));
    const playCookieCrack=()=>{
      const AudioEngine=window.AudioContext||window.webkitAudioContext;
      if(!AudioEngine)return;
      let context;
      try{
        context=new AudioEngine();
        const playCrack=(time,volume,pitch,crumb=false,bass=false)=>{
          const noise=context.createBuffer(1,Math.ceil(context.sampleRate*.055),context.sampleRate);
          const samples=noise.getChannelData(0);
          for(let i=0;i<samples.length;i++){
            samples[i]=(Math.random()*2-1)*Math.exp(-i/(context.sampleRate*(crumb?.004:.009)));
          }
          const source=context.createBufferSource();
          source.buffer=noise;
          const filter=context.createBiquadFilter();
          filter.type='bandpass';
          filter.frequency.value=1500*pitch;
          filter.Q.value=.7;
          const level=context.createGain();
          level.gain.setValueAtTime(0,time);
          level.gain.linearRampToValueAtTime(.45*volume,time+.002);
          level.gain.exponentialRampToValueAtTime(.0001,time+(crumb?.025:.055));
          source.connect(filter).connect(level).connect(context.destination);
          source.start(time);
          source.stop(time+.06);
          if(crumb||!bass)return;
          const body=context.createOscillator();
          body.type='triangle';
          body.frequency.setValueAtTime(420*pitch,time);
          body.frequency.exponentialRampToValueAtTime(110*pitch,time+.045);
          const envelope=context.createGain();
          envelope.gain.setValueAtTime(.16*volume,time);
          envelope.gain.exponentialRampToValueAtTime(.0001,time+.055);
          body.connect(envelope).connect(context.destination);
          body.start(time);
          body.stop(time+.06);
        };
        context.resume().then(()=>{
          const now=context.currentTime;
          playCrack(now,.8,.78,false,true);
          playCrack(now+.025,.16,1.05,true);
          playCrack(now+.049,.1,.9,true);
          playCrack(now+.16,.6,.85);
          [.018,.048,.083,.125,.173,.228,.291,.36].forEach((offset,index)=>{
            playCrack(now+.16+offset,.25*(1-index*.085),[1.1,.82,1.2,.95,1.05,.78,1.15,.9][index],true);
          });
          setTimeout(()=>context.close().catch(()=>{}),800);
        }).catch(()=>context.close().catch(()=>{}));
      }catch(error){if(context)context.close().catch(()=>{});}
    };
    cookie.addEventListener('click',()=>{
      playCookieCrack();
      refreshFortuneCode();
      copyButton.textContent=copyButton.dataset.copyLabel;
      copyStatus.textContent='';
      if(!fortune.open)fortune.showModal();
    });
    room.querySelector('.sc-room__fortune-close').addEventListener('click',()=>fortune.close());
    fortune.addEventListener('click',event=>{
      if(event.target!==fortune)return;
      const rect=fortune.getBoundingClientRect();
      if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)fortune.close();
    });
    fortune.addEventListener('close',()=>cookie.focus({preventScroll:true}));
    copyButton.addEventListener('click',async()=>{
      const code=refreshFortuneCode();
      let copied=false;
      if(navigator.clipboard&&window.isSecureContext){
        try{await navigator.clipboard.writeText(code);copied=true;}catch(error){}
      }
      if(!copied){
        const field=document.createElement('textarea');
        field.value=code;
        field.setAttribute('readonly','');
        field.style.cssText='position:fixed;left:0;top:0;opacity:0;pointer-events:none;';
        fortune.append(field);
        field.focus({preventScroll:true});field.select();field.setSelectionRange(0,field.value.length);
        try{copied=document.execCommand('copy');}catch(error){}
        field.remove();copyButton.focus({preventScroll:true});
      }
      copyStatus.textContent=copied?'':copyButton.dataset.copyFailed;
      copyButton.textContent=copied?copyButton.dataset.copiedLabel:copyButton.dataset.copyLabel;
    });
    dragon.addEventListener('click',()=>{
      const open=dragon.getAttribute('aria-expanded')!=='true';
      dragon.setAttribute('aria-expanded',String(open));
      greeting.hidden=!open;
    });
  });
}
initSoulmatesRooms();
document.addEventListener('shopify:section:load',initSoulmatesRooms);
(() => {
  const mobile = window.matchMedia("(max-width: 749px)");

  document.querySelectorAll("[data-sc-room]").forEach((room) => {
    const icons = room.querySelectorAll(
      ".sc-room__globe, " +
      ".sc-room__letter, .sc-room__bonsai, .sc-room__music, .sc-room__camera"
    );

    icons.forEach((icon) => {
      let timer;

      function scheduleJump() {
        if (!mobile.matches) return;

        timer = setTimeout(() => {
          if (!mobile.matches) return;

          icon.classList.remove("is-random-jumping");
          void icon.offsetWidth;
          icon.classList.add("is-random-jumping");

          const finishJump = event => {
            if (event.animationName !== 'sc-random-jump') return;
            icon.removeEventListener('animationend',finishJump);
            icon.classList.remove("is-random-jumping");
            scheduleJump();
          };
          icon.addEventListener("animationend",finishJump);
        }, Math.random() * 6000 + 2000);
      }

      scheduleJump();

      mobile.addEventListener("change", () => {
        clearTimeout(timer);
        icon.classList.remove("is-random-jumping");

        if (mobile.matches) scheduleJump();
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
